(function () {
    // https://tympanus.net/codrops/2019/09/25/mouse-flowmap-deformation-with-ogl/
    // https://stackoverflow.com/questions/39341564/webgl-how-to-correctly-blend-alpha-channel-png

    const ogl = window.ogl;

    const vertex = `
                    attribute vec2 uv;
                    attribute vec2 position;
                    varying vec2 vUv;
                    void main() {
                        vUv = uv;
                        gl_Position = vec4(position, 0, 1);
                    }
            `;
    const fragment = `
                    precision highp float;
                    precision highp int;
                    uniform sampler2D tWater;
                    uniform sampler2D tFlow;
                    uniform float uTime;
                    varying vec2 vUv;
                    uniform vec4 res;

                    void main() {
                        // R and G values are velocity in the x and y direction
                        // B value is the velocity length
                        vec3 flow = texture2D(tFlow, vUv).rgb;

                        vec2 uv = .5 * gl_FragCoord.xy / res.xy;

                        vec2 myUV = (uv - vec2(0.5)) * res.zw + vec2(0.5);
                        myUV -= flow.xy * (0.4);

                        gl_FragColor = texture2D(tWater, myUV);
                    }
            `;

    for (let element of document.querySelectorAll("img.distort-element, .distort-element img")) {
        const load = () => {
            element.removeEventListener("load", load);

            const renderer = new ogl.Renderer({
                dpr: 2,
                alpha: true
            });
            const gl = renderer.gl;
            element.parentElement.appendChild(gl.canvas);

            // Variable inputs to control flowmap
            let aspect = 1;
            const mouse = new ogl.Vec2(-1);
            const velocity = new ogl.Vec2();

            const flowmap = new ogl.Flowmap(gl, { falloff: 0.2, dissipation: 0.9 });
            // Triangle that includes -1 to 1 range for 'position', and 0 to 1 range for 'uv'.
            const geometry = new ogl.Geometry(gl, {
                position: {
                    size: 2,
                    data: new Float32Array([-1, -1, 3, -1, -1, 3])
                },
                uv: { size: 2, data: new Float32Array([0, 0, 2, 0, 0, 2]) }
            });
            const texture = new ogl.Texture(gl, {
                minFilter: gl.LINEAR,
                magFilter: gl.LINEAR
            });
            texture.image = element;

            let a1, a2;
            var imageAspect = element.height / element.width;
            if (element.height / element.width < imageAspect) {
                a1 = 1;
                a2 = element.height / element.width / imageAspect;
            } else {
                a1 = (element.width / element.height) * imageAspect;
                a2 = 1;
            }

            const program = new ogl.Program(gl, {
                vertex,
                fragment,
                uniforms: {
                    uTime: { value: 0 },
                    tWater: { value: texture },
                    res: {
                        value: new ogl.Vec4(element.width, element.height, a1, a2)
                    },
                    img: { value: new ogl.Vec2(element.width, element.height) },
                    // Note that the uniform is applied without using an object and value property
                    // This is because the class alternates this texture between two render targets
                    // and updates the value property after each render.
                    tFlow: flowmap.uniform
                }
            });
            const mesh = new ogl.Mesh(gl, { geometry, program });

            function resize() {
                if (!gl.canvas.hasAttribute("data-no-resize") || !gl.canvas.getAttribute("data-no-resize")) {
                    if (element.hasAttribute("data-no-resize")) {
                        gl.canvas.setAttribute("data-no-resize", element.getAttribute("data-no-resize"));
                    } else if (element.closest(".distort-element").hasAttribute("data-no-resize")) {
                        gl.canvas.setAttribute("data-no-resize", element.closest(".distort-element").getAttribute("data-no-resize"));
                    }

                    let a1, a2;
                    const imageAspect = element.height / element.width;
                    if (element.height / element.width < imageAspect) {
                        a1 = 1;
                        a2 = element.height / element.width / imageAspect;
                    } else {
                        a1 = (element.width / element.height) * imageAspect;
                        a2 = 1;
                    }
                    mesh.program.uniforms.res.value = new ogl.Vec4(
                        element.width,
                        element.height,
                        a1,
                        a2
                    );

                    renderer.setSize(element.width, element.height);
                    aspect = element.width / element.height;
                }
            }
            window.addEventListener("resize", resize, false);
            resize();

            // Create handlers to get mouse position and velocity
            //const isTouchCapable = "ontouchstart" in window;
            const isTouchCapable = false;
            if (isTouchCapable) {
                window.addEventListener("touchstart", updateMouse, false);
                window.addEventListener("touchmove", updateMouse, { passive: false });
            } else {
                window.addEventListener("mousemove", updateMouse, false);
            }
            let lastTime;
            const lastMouse = new ogl.Vec2();
            function updateMouse(e) {
                e.preventDefault();
                if (e.changedTouches && e.changedTouches.length) {
                    e.x = e.changedTouches[0].pageX;
                    e.y = e.changedTouches[0].pageY;
                }
                if (e.x === undefined) {
                    e.x = e.pageX;
                    e.y = e.pageY;
                }
                // Get mouse value in 0 to 1 range, with y flipped
                const rect = gl.canvas.getBoundingClientRect();
                mouse.set((e.x - rect.left) / rect.width, 1.0 - (e.y - rect.top) / rect.height);
                // Calculate velocity
                if (!lastTime) {
                    // First frame
                    lastTime = performance.now();
                    lastMouse.set(e.x, e.y);
                }

                const deltaX = e.x - lastMouse.x;
                const deltaY = e.y - lastMouse.y;

                lastMouse.set(e.x, e.y);

                const time = performance.now();

                // Avoid dividing by 0
                const delta = Math.max(10.4, time - lastTime);
                lastTime = time;
                velocity.x = deltaX / delta;
                velocity.y = deltaY / delta;
                // Flag update to prevent hanging velocity values when not moving
                velocity.needsUpdate = true;
            }
            window.requestAnimationFrame(update);
            function update(t) {
                window.requestAnimationFrame(update);
                // Reset velocity when mouse not moving
                if (!velocity.needsUpdate) {
                    mouse.set(-1);
                    velocity.set(0);
                }
                velocity.needsUpdate = false;
                // Update flowmap inputs
                flowmap.aspect = aspect;
                flowmap.mouse.copy(mouse);
                // Ease velocity input, slower when fading out
                flowmap.velocity.lerp(velocity, velocity.len ? 0.15 : 0.1);
                flowmap.update();
                program.uniforms.uTime.value = t * 0.01;
                renderer.render({ scene: mesh });
            }

            element.remove();
        };
        element.addEventListener("load", load);

        element.src = element.src; // trigger the "onload" event
    }
})();
